import { memo } from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../../../userAvatar';

const User = ({ user }) => {
  return <UserAvatar user={user} variant="subtitle1" small caption />;
};

User.propTypes = {
  user: PropTypes.object.isRequired,
};

export default memo(User);
